import React, { Fragment, useState } from 'react'
import styled, { css } from 'styled-components'

import { themeEstra } from 'src/styles/themeEstra'
import { clTransform } from 'src/utils/cloudinary'
import { Text } from 'app/components/ui/Text'
import { Button } from 'app/components/ui/Button'
import { Title } from 'app/components/ui/Title'
import { Modal } from 'app/components/ui/Modal'
import NewsletterModalForm from './NewsletterModalForm'

interface Props {
  initialEmailValue: string
  onToggle: (isVisible: boolean) => void
  isVisible: boolean
}

export const NewsletterModal: React.FC<Props> = ({
  isVisible,
  initialEmailValue,
  onToggle,
}) => {
  const [showThanks, setShowThanks] = useState(false)

  return (
    <Fragment>
      {isVisible && (
        <StyledModal
          onCloseRequest={() => onToggle(false)}
          title=''
          size='xl'
          hasOuterScroll
          isThankYou={showThanks}
        >
          {showThanks ? (
            <ThankYouWrapper>
              <ThankYouTitle>Grazie 1000!</ThankYouTitle>
              <Text variant='s24' color='#fff' mb={4}>
                Iscrivendoti alla nostra newsletter, sappiamo che ci hai dato
                fiducia e che ci metti alla prova.
                <br />
                Non ti deluderemo.
                <br />
                Una promessa è una promessa:
                <br />
                una sola volta al mese e contenuti interessanti (ci impegneremo
                al massimo per questo).
                <br />
                Se, poi, non sarà di tua soddisfazione, potrai sempre cancellare
                la tua iscrizione
                <br />
                direttamente dalla mail.
              </Text>
              <Button onClick={() => onToggle(false)} variant='nero'>
                Ok, ho letto. Chiudi e torna alla homepage
              </Button>
            </ThankYouWrapper>
          ) : (
            <Fragment>
              <Content>
                <Text
                  variant='s18'
                  mb={1.4}
                  weight='bold'
                  color={themeEstra.color.primari.grigioEstra}
                >
                  LA NEWSLETTER ESTRA
                </Text>
                <NewsletterTitle size={3}>
                  Da diversi anni informiamo i nostri amici con le ultime
                  notizie sull’energia e il futuro. Sei dei nostri?
                </NewsletterTitle>

                <FormWrapper>
                  <NewsletterModalForm
                    initialEmailValue={initialEmailValue || ''}
                    onSubmitSuccess={() => {
                      setShowThanks(true)
                    }}
                  />
                </FormWrapper>
              </Content>
              <div>
                <TextBottom>
                  Lo spam non piace a nessuno. Ecco perchè calibriamo
                  attentamente la quantità di email che inviamo e il loro
                  contenuto. Non condivideremo i tuoi dati con nessuno,
                  promesso. E se non ti piace, la disiscrizione si fa
                  direttamente dalla newsletter.
                </TextBottom>
              </div>
            </Fragment>
          )}
        </StyledModal>
      )}
    </Fragment>
  )
}

export default NewsletterModal

interface StyledModalProps {
  isThankYou?: boolean
}

const bgModal = clTransform({
  url:
    'https://res.cloudinary.com/estra/image/upload/f_auto/v1611736580/estra20dev/area_fornitori/modals/bg_newsletter_modal.png',
})
const bgModalThanks = clTransform({
  url:
    'https://res.cloudinary.com/estra/image/upload/f_auto/v1611736579/estra20dev/area_fornitori/modals/bg_newsletter_modal_thanks.png',
})

const StyledModal = styled(Modal)<StyledModalProps>`
  ${({ isThankYou }) =>
    isThankYou
      ? css`
          background-image: url("${bgModalThanks}");
          background-size: cover;
          background-position: center;
          background-repeat: no-repeat;
        `
      : css`
          @media (min-width: ${themeEstra.bp.tablet}) {
            background-image: url("${bgModal}");
            background-size: cover;
            background-position: center;
            background-repeat: no-repeat;
            padding-left: 6rem;
          }
        `}
`

const Content = styled.div`
  max-width: 445px;
`

const NewsletterTitle = styled(Title)`
  @media (min-width: ${themeEstra.bp.desktop}) {
    color: ${themeEstra.color.secondari.cianoScuro};
  }
`

const FormWrapper = styled.div`
  margin-top: 3rem;
`

const TextBottom = styled(Text)`
  color: ${themeEstra.color.neutri.grigio};
  font-style: italic;
  margin-top: 3.75rem;
  margin-bottom: 2rem;
`

const ThankYouWrapper = styled.div`
  text-align: center;
  max-width: 540px;
  margin: 0 auto;

  @media (min-width: ${themeEstra.bp.tablet}) {
    padding: 2rem 0 4rem;
  }

  @media (max-width: ${themeEstra.bp.mobile}) {
    button {
      line-height: 1.2;
      height: auto;
      padding: 0.5rem 1.6rem;
    }
  }
`

const ThankYouTitle = styled(Text)`
  color: #fff;
  margin-bottom: 2rem;
  font-weight: bold;
  font-size: 2rem;
  @media (min-width: ${themeEstra.bp.tablet}) {
    font-size: 72px;
  }
`
